<div [ngClass]="['cell', resourcesCssService.responsiveClass()]">
  <div class='badge'>
    <button (click)='goToArticle()'><i [ngClass]='icon'></i></button>
  </div>
  <div class='info'>
    <button (click)='goToArticle()'>{{ article.title }}</button>
    <span class="blog-date">{{ article.createdAt.month }} {{ article.createdAt.day }}, {{ article.createdAt.year }}</span>
    <div class="article-content" [innerHTML]="articleSummary"></div>
    <p><a (click)='goToArticle()' class="read-more">Read More</a></p>
  </div>
</div>